import React, { useMemo, useState } from "react";
import TurnstileWidget from "../components/Turnstile";
import { apiPost } from "../lib/api";

type TenantLeadCreated = {
  leadId: string;
  receivedAt?: string;
  echo?: unknown;
};

export default function LeadsTenant() {
  const siteKey = (import.meta as any).env?.VITE_TURNSTILE_SITEKEY ?? "";

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    city: "Barcelona",
    notes: "",
    privacyAccepted: true,
    turnstileToken: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState<any>(null);

  const canSubmit = useMemo(() => {
    return (
      form.name.trim() &&
      form.phone.trim() &&
      form.city.trim() &&
      form.privacyAccepted &&
      form.turnstileToken.trim() &&
      !submitting
    );
  }, [form, submitting]);

  async function submit() {
    setSubmitting(true);
    setResult(null);

    const payload = {
      name: form.name,
      phone: form.phone,
      email: form.email || null,
      city: form.city,
      notes: form.notes || null,
      consents: {
        privacyPolicyAccepted: form.privacyAccepted,
      },
      turnstileToken: form.turnstileToken,
    };

    const resp = await apiPost<TenantLeadCreated>("/v1/tenant-leads", payload);

    setSubmitting(false);
    setResult(resp);
  }

  return (
    <div className="card">
      <h2>租客线索（/v1/tenant-leads）</h2>
      <p className="muted">
        该表单严格按 M0 OpenAPI 的最小必填字段提交：name / phone / city / consents / turnstileToken。
      </p>

      <div className="row">
        <label>
          姓名*
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </label>
        <label>
          电话*
          <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        </label>
      </div>

      <div className="row">
        <label>
          Email
          <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </label>
        <label>
          城市*
          <input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
        </label>
      </div>

      <label>
        备注
        <textarea rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
      </label>

      <label style={{ display: "block", marginTop: 12 }}>
        <input
          type="checkbox"
          checked={form.privacyAccepted}
          onChange={(e) => setForm({ ...form, privacyAccepted: e.target.checked })}
        />{" "}
        我已阅读并同意隐私政策（privacyPolicyAccepted=true）*
      </label>

      <div className="card">
        <h3>Turnstile</h3>
        <TurnstileWidget
          siteKey={siteKey}
          onToken={(token) => setForm((p) => ({ ...p, turnstileToken: token }))}
          action="tenant_lead_submit"
        />

        {!siteKey ? (
          <div style={{ marginTop: 12 }}>
            <div className="muted">
              当前未配置 SiteKey：为了试跑流程，你可以手动填一个 token（mock 模式会接受任何非空字符串）。
            </div>
            <input
              placeholder="turnstileToken (dev/mock)"
              value={form.turnstileToken}
              onChange={(e) => setForm({ ...form, turnstileToken: e.target.value })}
            />
          </div>
        ) : null}
      </div>

      <button disabled={!canSubmit} onClick={submit}>
        {submitting ? "Submitting…" : "提交线索"}
      </button>

      {result ? (
        <div className="card">
          <h3>Response</h3>
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
      ) : null}
    </div>
  );
}
